import React from 'react'
import { Box, IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'
import { IoChevronDownOutline } from "react-icons/io5";
import { redirectToNewPage } from '../../global/helpers/global-helpers';


export default function DsrHeaderMoreOptionsButton({ 
  handleUnpublishRoom,
  dsrId,
  isLockedRoom,
  lockedRoomMetadata
}) {

  
  function renderOptions() {
    if (isLockedRoom) {
      const {lockerUserName} = lockedRoomMetadata || {};

      return (
        <MenuList p='0.875em 0.5em' fontSize='0.875em'>
        <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' cursor='default'>
        <Box >
            <Box fontWeight='600' fontSize='1em' color='brandDark.500'>Edit options unavailable</Box>
            <Box fontWeight='400' fontSize='0.875em'>  <i>{lockerUserName}</i> is currently editing the Room and it's been locked temporarily </Box>
        </Box>
    
        </MenuItem>
      </MenuList>
      )
    } else {
      return (
        <MenuList px='0.5em' fontSize='0.875em'>
        {dsrId && <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => redirectToNewPage(`/edit/${dsrId}`)}  >Edit Room</MenuItem>}
        <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => handleUnpublishRoom()}  >Unpublish Room</MenuItem>
      </MenuList>
      )
    }
  }
  return (
    <React.Fragment>

      <Menu isLazy placement="bottom-end" bg='gray.500'>
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<IoChevronDownOutline />}
          // variant='outline'
          size='2em'
          p='0.5em'
          rounded='50%'
        />
       {renderOptions()}
      </Menu>

    </React.Fragment>
  );

}